export default __webpack_public_path__ + "static/media/mortgagemenuicon.70a28b82.svg";